// Generated by petlings-ios-app/scripts/pet-art/install_web.py, do not edit by hand.
// Cosmetics with voxel art in public/cosmetics/art/.
export const ART_COSMETICS = new Set([
  '3d_glasses',
  'angel_wings',
  'armorer_hat',
  'astronaut_fishbowl',
  'aurora_shawl',
  'aviator_goggles',
  'backpack',
  'ballerina_slippers',
  'bandana',
  'barrel',
  'bat_wings',
  'bear_ears',
  'bear_tail',
  'beehive_hat',
  'bell_necklace',
  'beret',
  'black_glasses',
  'black_sunglasses',
  'blue_collar',
  'bow_tie',
  'box_backpack',
  'boy_backpack',
  'brown_glasses',
  'butcher_hat',
  'butterfly_wings',
  'butterfly_wings_1',
  'butterfly_wings_10',
  'butterfly_wings_2',
  'butterfly_wings_3',
  'butterfly_wings_4',
  'butterfly_wings_5',
  'butterfly_wings_6',
  'butterfly_wings_7',
  'butterfly_wings_8',
  'butterfly_wings_9',
  'candy_sprinkles',
  'cartographer_hat',
  'cat_ears',
  'cat_eye_shades',
  'cat_tail',
  'chicken_hat',
  'cleric_hat',
  'clockwork_collar',
  'cow_ears',
  'cow_horns',
  'cow_tail',
  'crossed_sword',
  'crown',
  'cyborg_visor',
  'cyborg_visor_green',
  'cyborg_visor_red',
  'deal_with_it_glasses',
  'deer_ears',
  'deer_horns',
  'deer_tail',
  'desert_villager_hat',
  'devil_horns',
  'diamond_sword',
  'dragon_head',
  'dragon_head_aether',
  'dragon_head_green',
  'dragon_head_nether',
  'ent_mask',
  'farmer_hat',
  'fire_trail',
  'fisherman_hat',
  'fletcher_hat',
  'flower_crown',
  'fox_ears',
  'fox_tail',
  'frankenstein_hat',
  'frog_hat',
  'galaxy_cloak',
  'gas_mask',
  'gentlemen_bowtie',
  'ghost_wisps',
  'girl_backpack',
  'glacial_crown',
  'goat_ears',
  'goat_horns',
  'goat_tail',
  'gold_chain',
  'golden_boots',
  'headphones',
  'heart_glasses',
  'heart_monocle',
  'heart_trail',
  'horse_ears',
  'horse_horns',
  'horse_tail',
  'illusioner_hat',
  'jester_cap',
  'librarian_hat',
  'lollipop_staff',
  'luminous_choker',
  'magic_wand',
  'mini_cauldron',
  'moon_boots',
  'moon_wizard_cloak',
  'moon_wizard_hat',
  'moon_wizard_staff',
  'moth_wing_cape',
  'musical_note',
  'neon_sunglasses',
  'new_years_hat',
  'phoenix_helm',
  'pirate_hat',
  'pitchfork',
  'pixel_glasses',
  'pixel_visor',
  'pocket_lute',
  'propeller_pack',
  'pufferfish_hat',
  'rabbit_ears',
  'rabbit_tail',
  'rage_helmet',
  'rain_boots',
  'rainbow_cape',
  'rainbow_sneakers',
  'rainbow_sunglasses',
  'red_cape',
  'red_collar',
  'round_glasses',
  'royal_cape',
  'royal_crown',
  'royal_staff',
  'santa_hat',
  'savanna_villager_hat',
  'scarf',
  'sheep_ears',
  'sheep_horns',
  'sheep_tail',
  'shepherd_hat',
  'snow_trail',
  'snow_villager_hat',
  'space_helmet',
  'spiked_collar',
  'star_trail',
  'star_wand',
  'storm_halo',
  'strapped_banjo',
  'sun_wizard_cloak',
  'sun_wizard_hat',
  'sun_wizard_staff',
  'sunglasses',
  'swamp_villager_hat',
  'tea_cup',
  'techno_cape',
  'techno_crown',
  'techno_sword',
  'tiger_ears',
  'tiger_tail',
  'tint_sunglasses',
  'tiny_boots',
  'tiny_sword',
  'top_hat',
  'turtle_shell_pack',
  'vindicator_hat',
  'volcano_peak',
  'volt_wings',
  'war_paint_stripes',
  'weaponsmith_hat',
  'witch_hat',
  'wizard_hat',
  'wizard_quill',
  'wolf_ears',
  'wolf_tail',
  'wooden_bucket',
  'wooden_shield',
  'wooden_wheel',
  'xray_glasses',
]);
